<div [class.disabled]="disabled" class="tags-input-shell">
    <div *ngFor="let tag of tags" class="inline-flex items-center gap-1 h-6 px-3 rounded-full bg-gray-200 border border-neutral-200 shadow-none">
        <span class="text-[12px] font-normal text-gray-500 leading-none">{{ tag }}</span>
        <button type="button" class="text-[12px] text-gray-500 leading-none" (click)="removeTag(tag)" [disabled]="disabled" aria-label="Remove tag">×</button>
    </div>

    <div
        #container
        class="flex items-center h-6 px-3 rounded-full bg-transparent border border-transparent shadow-none cursor-pointer"
        (click)="openInput($event)">
        <span class="text-sm text-gray-500 leading-none mr-1">+</span>

        <ng-container *ngIf="!showInput">
            <span class="text-[12px] font-normal text-gray-500 leading-none select-none">Add new tag</span>
        </ng-container>

        <input
            *ngIf="showInput"
            #inputElement
            class="tag-input flex-1 min-w-[96px] bg-transparent text-[12px] font-normal text-gray-500 placeholder-gray-400 focus:outline-none"
            [formControl]="tagInput"
            [matAutocomplete]="auto"
            matAutocompleteTrigger
            [matAutocompleteDisabled]="disabled"
            (click)="$event.stopPropagation()"
            (keyup.enter)="addTag()"
            (keydown.enter)="$event.preventDefault();"
            [placeholder]="disabled ? '' : 'Add new tag'"
            [disabled]="disabled" />
    </div>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTagSelected($event)">
        <mat-option *ngFor="let suggestion of filteredSuggestions | async" [value]="suggestion">
            {{ suggestion }}
        </mat-option>
    </mat-autocomplete>
</div>
